import type { TFunction } from 'i18next';
import type { ISchedulerDependency } from '@interfaces/IScheduler';

/** A link's type and lag as read-only text, e.g. "Finish → Start · 2d" / "FS（終了→開始） · 2日". */
export function depSummary(dep: Pick<ISchedulerDependency, 'type' | 'lagDays'>, t: TFunction): string {
  return `${t(`scheduler.linkType.${dep.type}`)} · ${t('scheduler.arrows.lag', { lag: dep.lagDays })}`;
}
